import { Link } from 'react-router-dom';
import { Product } from '@/mocks/products';

interface ProductCardProps {
  product: Product;
}

const categoryLabel: Record<Product['category'], string> = {
  cadeira: 'Cadeira',
  mesa: 'Mesa',
  aco: 'Mobiliário de Aço',
  cabine: 'Cabine Acústica',
  divisoria: 'Divisória Modular',
  persiana: 'Persiana',
};

const categoryPath: Record<Product['category'], string> = {
  cadeira: '/contato',
  mesa: '/contato',
  aco: '/contato',
  cabine: '/contato',
  divisoria: '/contato',
  persiana: '/contato',
};

export default function ProductCard({ product }: ProductCardProps) {
  return (
    <Link to={categoryPath[product.category]} className="group block cursor-pointer">
      <div className="img-zoom rounded-xl overflow-hidden bg-background-100 aspect-[4/5]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="pt-4">
        <p className="text-[11px] text-primary-600 font-medium uppercase tracking-wider">
          {categoryLabel[product.category]}
        </p>
        <h3 className="text-foreground-900 font-medium text-[15px] mt-1 leading-snug">{product.name}</h3>
        <p className="text-foreground-400 text-[13px] font-light mt-0.5">{product.brand}</p>
      </div>
    </Link>
  );
}